import { Component, Input } from '@angular/core';
import { CDN_IMAGES } from '../../constants/param-constants';

@Component({
  selector: 'brand-reviews',
  templateUrl: 'brand-reviews.html',
  styleUrls: ['brand-reviews.scss'],
})
export class BrandReviewsComponent {

  @Input() reviewsTitle: string = `<h2 class="reviews_titleContent">SUCCESS STORIES</h2>`;
  @Input() disclaimer: string = '*Individual results may vary';
  @Input() star: string = CDN_IMAGES.STAR_GREEN;
  @Input() reviews: any[] = [];

  Arr = Array;

  constructor() { }


}
